import { NgModule } from "@angular/core";
import { ImprintComponent } from "./imprint.component";
import { L10nTranslationModule } from "angular-l10n";

@NgModule({
  declarations: [
    ImprintComponent
  ],
  imports: [
    L10nTranslationModule
  ],
  exports: [
    ImprintComponent
  ]
})
export class ImprintModule {}
